


















import { Component, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class TooltipTextField extends Vue {
  get tooltipText(): string {
    return (this.$attrs.value as string) || '';
  }

  get showTooltip(): boolean {
    return !!this.tooltipText;
  }
}
